"use client"

import React from 'react';
import MapComponent from "@/components/Map/MapComponent";
import usePathData from "@/utils/hooks/usePathData";
import {GpxFile} from "@/types/Paths";
import Gpx from "@/components/PathMap/Gpx";

export default function PathMap(props: { id: string }) {
  const data = usePathData(props.id)
  const {gpx_files, map_zoom, map_center_lat, map_center_lon} = data || {}

  // `zoom` deriva da `map_zoom`: default 8 finche' i dati non arrivano.
  const zoom = map_zoom || 8

  if (!gpx_files) return null

  return <div>
    <MapComponent
      gpxs={gpx_files}
      lat={map_center_lat}
      lng={map_center_lon}
      style={{width: '100%', height: '400px', marginTop: "1rem"}} zoom={zoom}>
      {gpx_files && gpx_files.map((itm: GpxFile, key: number) => {
        return <Gpx key={key} file={itm.url}/>
      })}
    </MapComponent>
  </div>
}
